<div class="container">
  <div class="row">
    <div class="col-md-12 text-center page404 text-success" style="margin-top: 50px">
      <i class="fas fa-check" style="font-size: 49px"></i>
      <p>{{ 'connections_page.success' | translate }}</p>
    </div>
    <div class="col-md-12 text-center page404">
      <button class="btn btn-success btn-md" (click)="LinktoPage('/auth/redirect')">
        {{ 'connections_page.back_home' | translate }}
      </button>
    </div>
  </div>
</div>
